import { apiRequest, getResource } from "../api/http";

// Mobile app page: live Firestore configuration (AppConfig/configs,
// app_version/update_info) and the "Update available" notification.
// "mobile_app" section: view to read, edit to change and send.
const BASE = "/api/admin/mobile-app";

/** `{ docs: [{ path, label, updatedAt, fields: [{ key, label, type, value }] }], stores }`. */
export const getAppConfig = () => getResource(`${BASE}/config`, { fallback: null });

/** Changes existing fields of one document → the new configuration. Rejects with the API message. */
export const updateAppConfig = (path, changes) =>
  apiRequest("patch", `${BASE}/config`, { data: { path, changes }, select: (data) => data.config, rethrow: true });

/** `{ items, defaults: { title, body }, stores }`. */
export const getUpdatePushes = () => getResource(`${BASE}/update-push`, { fallback: null });

/** `{ platform: "all" | "android" | "ios", title, body, latestVersion }`. */
export const sendUpdatePush = (body) => apiRequest("post", `${BASE}/update-push`, { data: body, select: (data) => data.notification, rethrow: true });

export const apiError = (error) => error?.response?.data?.message || "";
